export default "__VITE_ASSET__a34UcsC0__"